<template>
  <div class="cf-node-properties__routing-filter row">
    <div
      key="filter"
      class="cf-node-properties__field col-sm-6 m-b-0"
    >
      <label class="control-label">
        {{ $t('SPLIT_TEST_LINK_SETTING_FILTER') }}
        <span>*</span>
        <i
          v-tooltip.top="$t('SPLIT_TEST_LINK_SETTINGSPLIT_TEST_FILTER_TT')"
          class="fa fa-question-circle m-l-5"
          aria-hidden="true"
        />
      </label>
      <InputText
        v-model="route.filter"
        :required="true"
        @input="inputChange"
      />
      <div
        v-if="route.filter == null || route.filter == ''"
        class="cf-node-properties__input-error p-r-15"
      >
        {{ $t('ERROR_MUST_HAVE_VALUE') }}
      </div>
    </div>
    <div
      key="weight"
      class="cf-node-properties__field col-sm-6 m-b-0"
    >
      <label class="control-label">
        {{ $t('SPLIT_TEST_LINK_SETTING_WEIGHT') }}
        <span>*</span>
        <i
          v-tooltip.top="$t('SPLIT_TEST_LINK_SETTING_WEIGHT_TT')"
          class="fa fa-question-circle m-l-5"
          aria-hidden="true"
        />
      </label>
      <InputNumber
        v-model="route.weight"
        :required="true"
        @input="inputChange"
      />
      <div
        v-if="route.weight <= 0 || route.weight > 999"
        class="cf-node-properties__input-error p-r-15"
      >
        {{ $t('ERROR_OUT_OF_RANGE') }}
      </div>
    </div>
  </div>
</template>

<script>
import InputNumber from '../Form/InputNumber';
import InputText from '../Form/InputText.vue';
import messages from '../../../../locales';

export default {
  components: {
    InputText,
    InputNumber,
  },
  props: ['route'],
  methods: {
    inputChange() {
      this.route.name = this.route.filter;
      this.route.criteria[0].tagCriteria[0].value = this.route.filter;
      this.$emit('route-change', this.route);
      this.$emit('update:route', this.route);
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>